/**
 * 消息类型常量定义
 * 统一使用子窗体的消息类型常量
 */
export const MESSAGE_TYPES = {
  // 初始化相关 - 使用子窗体的类型
  INIT: 'INIT',
  LOGOUT: 'LOGOUT',
  INIT_CHAT: 'INIT_CHAT',
  CHAT_READY: 'CHAT_READY',
  CHAT_LOG: 'CHAT_LOG',

  // 会话切换相关 - 使用子窗体的类型
  SWITCH_CONVERSATION: 'SWITCH_CONVERSATION',
  SWITCH_CONVERSATION_SUCCESS: 'SWITCH_CONVERSATION_SUCCESS',
  SWITCH_CONVERSATION_FAILED: 'SWITCH_CONVERSATION_FAILED',

  // iframe状态相关 - 使用子窗体的类型
  MOUNTED: 'MOUNTED',

  // 滚动相关 - 使用子窗体的类型
  SCROLL_TO_BOTTOM: 'SCROLL_TO_BOTTOM',
  SCROLL_TO_TOP: 'SCROLL_TO_TOP',

  // 通知相关
  NOTIFY_COMPLETE: 'NOTIFY_COMPLETE',
};

/**
 * 事件类型常量定义
 * 用于统一管理自定义事件类型
 */
export const EVENT_TYPES = {
  CONVERSATION_SWITCHED: 'conversation-switched',
  CONVERSATION_SWITCH_ERROR: 'conversation-switch-error',
  CHAT_LOGIN_SUCCESS: 'chat-login-success',
  CHAT_LOGIN_ERROR: 'chat-login-error',
  CHAT_LOGOUT_SUCCESS: 'chat-logout-success',
  CHAT_LOGOUT_ERROR: 'chat-logout-error',
  IFRAME_READY: 'iframe-ready',
};

/**
 * 错误类型常量
 */
export const ERROR_TYPES = {
  WARNING: 'warning',
  ERROR: 'error',
};

/**
 * 错误消息常量
 */
export const ERROR_MESSAGES = {
  IFRAME_NOT_EXISTS: 'iframe 不存在',
  IFRAME_NOT_CONFIGURED: 'iframe 未正确配置',
  MISSING_CONVERSATION_ID: '缺少会话ID',
  MISSING_CREDENTIALS: '缺少登录凭证',
  MISSING_SERVICE_USER_ID: '缺少服务用户ID',
  SWITCH_CONVERSATION_TIMEOUT: '切换会话超时',
  SWITCH_CONVERSATION_FAILED: '切换会话失败，请重试',
  INIT_CHAT_FAILED: '初始化聊天失败',
  LOGOUT_FAILED: '注销失败',
  LOGIN_FAILED: '登录失败',
  LOGOUT_TIMEOUT: '等待注销成功超时',
  LOGIN_TIMEOUT: '等待登录成功超时',
  IFRAME_NOT_READY: 'iframe 未就绪',
};
